import { ConfigurationManagerPage } from "./configuration-manager-page/configuration-manager-page";
import { Login } from "./login/login";
import { Logout } from "./logout/logout";
import { RefreshTokenExpiredErrorPage } from "@components/pages/refresh-token-expired-error-page/refresh-token-expired-error-page";
import { ServerErrorPage } from "./server-error-page/server-error-page";
import { SpinnerPage } from "./spinner-page/spinner-page";
import { NodeManagerPage } from "./nodemanager/node-manager-page";
import { GatewaysAndSourcesListPage } from "./gateways-list-page/gateways-list-page";
import { UserManagementPage } from "./user-management-page/user-management-page";
import { VncPage } from "./vnc-page/vnc-page";
import { MachinesListPage } from "./machines-list-page/machines-list-page";
import { PermissionMissing } from "./permission-missing-page/permission-missing-page";
import { TicketsPage } from "./tickets-page/tickets-page";
import { DashboardsPage } from "./dashboards-page/dashboards-page";
import { DashboardViewerPage } from "./dashboards-page/dashboard-viewer-page";
import { ThingsOSHomepage } from "./things-os-homepage/things-os-homepage";
import { FactoryDashboardPage } from "./factory-dashboard/factory-dashboard";
import { AdminPanelPage } from "./admin-panel-page/admin-panel-page";

const pages = {
  ConfigurationManagerPage,
  Login,
  Logout,
  NodeManagerPage,
  PermissionMissing,
  RefreshTokenExpiredErrorPage,
  ServerErrorPage,
  GatewaysAndSourcesListPage,
  SpinnerPage,
  UserManagementPage,
  MachinesListPage,
  TicketsPage,
  DashboardsPage,
  DashboardViewerPage,
  VncPage,
  ThingsOSHomepage,
  FactoryDashboardPage,
  AdminPanelPage,
};

export default pages;
